import { doMemoAxiosReq } from '@infl-ts/util-hub-axios-instance';
import * as DE from '@nll/datum/lib/DatumEither';
import { pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
import { useEffect, useState } from 'react';
export var StreamTokenResponse = t.type({
  contact_id: t.string,
  hub_id: t.string,
  subdomain: t.string
});
export var streamTokenRequestConfig = {
  method: 'GET',
  url: '/stream_io/token',
  data: null,
  withCredentials: true,
  headers: {
    Accept: 'application/jwt'
  }
};
var getMemoStreamTokenTE = doMemoAxiosReq(streamTokenRequestConfig);
var getStreamTokenTE = pipe(getMemoStreamTokenTE, TE.map(function (x) {
  return x.data;
}));
export var useStreamToken = function useStreamToken() {
  var _useState = useState(DE.initial),
      streamToken = _useState[0],
      setStreamToken = _useState[1];

  useEffect(function () {
    setStreamToken(DE.pending);
    void pipe(getStreamTokenTE, TE.chainEitherKW(function (data) {
      return StreamTokenResponse.decode(data);
    }), TE.matchW(function () {
      return DE.failure('Could not fetch stream token');
    }, DE.success), T.chainIOK(function (status) {
      return function () {
        return setStreamToken(status);
      };
    }))();
  }, []);
  return streamToken;
};